var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"locations_widget"}},[_c('locations-list'),_c('location-details'),_c('div',{attrs:{"id":"map_canvas"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }